import React from 'react';

interface EstimationLogoProps {
  className?: string;
  variant?: 'light' | 'dark';
}

export function EstimationLogo({ className = "h-8 w-8", variant = 'light' }: EstimationLogoProps) {
  // ESti.png = white logo (for dark backgrounds)
  // lightmode.png = black logo (for light backgrounds)
  const logoSrc = variant === 'dark' ? '/lightmode.png' : '/ESti.png';

  return (
    <img
      src={logoSrc}
      alt="Estimation.pk Logo"
      className={`${className} object-contain transition-opacity duration-200`}
    />
  );
}

// Simplified version for favicon/small uses - also uses PNG
export function EstimationLogoSimple({ className = "h-6 w-6", variant = 'light' }: { className?: string; variant?: 'light' | 'dark' }) {
  // ESti.png = white logo (for dark backgrounds)
  // lightmode.png = black logo (for light backgrounds)
  const logoSrc = variant === 'dark' ? '/lightmode.png' : '/ESti.png';
  
  return (
    <img 
      src={logoSrc}
      alt="Estimation.pk Logo"
      className={`${className} object-contain`}
    />
  );
}